module.exports = __webpack_public_path__ + "static/media/Contract Manufacturers Infographic desktop 07-02-2024 C.0964fc68.gif";